import React, { useState } from 'react';
// Icons
import { settingsIcon } from '../../../constants/icon';

import Sidebar from '../../../components/sidebar';
import InnerSidebar from '../../../components/sidebar/innerSidebar';
import HeaderNavigation from '../../../components/headerNavigation';
import InnerSidebarHeader from '../../../components/sidebar/innerSidebarHeader';
import InnerSidebarList from '../../../components/sidebar/innerSidebarList';
import UserMgmtTable from './user/userMgmtTable';

function UserManagement() {
  const [isInnerSidebarActive, setIsInnerSidebarActive] = useState(true);
  const hideSidebar = () => {
    setIsInnerSidebarActive(!isInnerSidebarActive);
  };
  return (
    <>
      <Sidebar />
      <main className="main-content-wrapper">
        <div className={`content-wrapper ${isInnerSidebarActive ? 'active' : ''}`}>
          <div className="content-block relative">
            <InnerSidebar className={isInnerSidebarActive ? 'show-sidebar' : 'hide-sidebar'}>
              {isInnerSidebarActive && (
                <>
                  <InnerSidebarHeader
                    title="Settings"
                    subTitle="Manage all setting"
                    icon={settingsIcon}
                  />
                  <InnerSidebarList />
                </>
              )}
            </InnerSidebar>
            <span className="show-hide-sidebar" onClick={hideSidebar}>
              {isInnerSidebarActive ? '<' : '>'}
            </span>
            <HeaderNavigation />
             <UserMgmtTable />
          </div>
        </div>
      </main>
    </>
  );
}
export default UserManagement;
